import { useEffect, useContext, useState } from "react";
import axios from "axios";
import { useParams, useNavigate } from "react-router-dom";
import "./Css/Card.css"; // Adjust the path as necessary
import { AppContext } from "../../context/AppContext";

const SearchGameWrapper = () => {
  const { categoryName } = useParams();
  const [cardsData, setCardsData] = useState([]);
  const navigate = useNavigate();
  const {
    baseUrl,
    gameUrl,
    Backend_folder_path,
    addGameUrl,
    setCategory,
    gameList,
    setgamelist,
    setdescreption,
    setPageRefreshCount,
    metaTag,
    setgametitle,
    setmetadata,
    setgametype,
    setgameid,
    setappstorelink,
    addThumbImg,
    AppStoreLink,
    setThumbImgStatus,
    setGameIframeStatus,
  } = useContext(AppContext);
  useEffect(() => {
    const newCards = gameList.map((game, index) => ({
      title: `${game.game_title}`, // optional formatting
      id: index + 1,
      path: `${Backend_folder_path}${game.folder_path}/index.html`,
      thumb_img: `${Backend_folder_path}${game.thumbnail_img_path}`,
      url: game.url,
      category: game.category,
      descreption: game.description,
      enable: game.enable,
      title: game.game_title,
      meta_title: game.meta_title,
      meta_keyword: game.meta_keyword,
      meta_description: game.meta_description,
      gameType: game.gameType,
      gameId: game.id,
      iso_link: game.iso_link,
      playstore_link: game.playstore_link,
    }));
    setCardsData(newCards);
  }, [gameList]);
  const handleClick = (game) => {
    setThumbImgStatus(true);
    setGameIframeStatus(false);
    // navigate to the game layout with selected image

    const url = game.url;
    addGameUrl(game.path);
    addThumbImg(game.thumb_img);
    setCategory(game.category);
    setdescreption(game.descreption);
    setgametitle(game.title);
    setmetadata({
      title: game.meta_title,
      keywords: game.meta_keyword,
      descreption: game.meta_description,
    });
    setgametype(game.gameType);
    setgameid(game.gameId);
    setappstorelink({
      ...AppStoreLink,
      iso_link: game.iso_link,
      playstore_link: game.playstore_link,
    });

    navigate(`/game/${url}`);
  };
  return (
    <>
      <div className="gallery-container">
        <h1 style={{ fontSize: "14px" }}>
          Free Online Games - <span>htmlgames4u.com</span>
        </h1>
        <div className="game-grid">
          {cardsData.map(
            (game) =>
              game.enable && (
                <div
                  style={{ cursor: "pointer" }}
                  className="game-card"
                  key={game.id}
                >
                  <img
                    onClick={() => handleClick(game)}
                    src={game.thumb_img}
                    alt={game.title}
                  />
                </div>
              )
          )}
        </div>
        {cardsData.length == 0 && (
          <div style={{ fontSize: "20px", fontWeight: "bold", color: "red" }}>
            No Games Available...
          </div>
        )}
      </div>
    </>
  );
};
export default SearchGameWrapper;
